import React, { useCallback } from 'react';
import { AlmeAppState, createChannelTypes } from '../components/AlmeApp/AlmeAppState';
import { AlmeApiUtils } from "../api/AlmeApiUtils";

export function useResetIvaCallback(
    almeState: AlmeAppState,
    apiUtils: React.MutableRefObject<AlmeApiUtils>,
    setAlmeState: (state: AlmeAppState) => void,
    clearSessionData: () => void,
    isInitialized: React.MutableRefObject<boolean>,
    personaMapped: React.MutableRefObject<boolean>,
    verintAccessKey?: React.MutableRefObject<string>,
    isIvaProLaunch?: React.MutableRefObject<boolean>,
): (isOpen: boolean, sessionEndReason: string, shouldResetIsInitialized?: boolean, resetSessionData?: boolean) => Promise<void> {
    return useCallback(async (isOpen: boolean, sessionEndReason: string, shouldResetIsInitialized?: boolean, resetSessionData = true) => {
        await apiUtils.current.submitReportingEvent('SessionEnd', sessionEndReason);
        if (resetSessionData) { clearSessionData(); }
        const newState: AlmeAppState = {
            ...almeState,
            isOpen,
            history: [],
            liveChatIndex: -1,
            isLiveChatConnected: false,
            agentChannel: createChannelTypes(),
        };
        if (almeState.isDialogOpen) {
            newState.isDialogOpen = false;
        }
        personaMapped.current = false;
        if (verintAccessKey)
            verintAccessKey.current = '';
        if (isIvaProLaunch)
            isIvaProLaunch.current = false;
        setAlmeState(newState);
        if (shouldResetIsInitialized && isInitialized.current) {
            isInitialized.current = false;
        }
    }, [almeState, apiUtils, clearSessionData, isInitialized, isIvaProLaunch, personaMapped, setAlmeState, verintAccessKey]);
}
